import { Component, OnInit, Input, TemplateRef, EventEmitter, Output } from '@angular/core';
import { isNullOrUndefined } from 'util';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-table-cell, [lib-table-cell]',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.css']
})
export class TableCellComponent implements OnInit {

  @Input() cellData: any;
  @Input() isTotalData: boolean;
  @Input() hieType: string;
  @Input() lastLevel: string;
  // @Input() template: TemplateRef<any>;
  @Output() onCellClick = new EventEmitter<Object>();


  private modalRef;
  currentTemplate: TemplateRef<any>;

  constructor(
    // private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  click(element: any): void {
    this.onCellClick.emit(element);
  }

  popupCalled(index) {
    // this.modalService.open(PopupConstant[this.cellData.popupInfo.component]);
  }

  formatNumber(value, fixedTo: number = 2) {
    if (isNullOrUndefined(value) || value == Number.MIN_VALUE || value == Number.MAX_VALUE) {
      return '-';
    }
    // console.log(value,isNumber(value),isNaN(value))
    if (!isNaN(+value)) {
      return parseFloat((+value).toFixed(fixedTo)).toLocaleString('en-IN', {
        maximumFractionDigits: fixedTo
      });
    } else {
      return value;
    }
  }

  transformFloat(value) {
    if (!isNaN(parseFloat(value))) {
      return (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2);
    } else {
      return value;
    }
  }

}